//@ flow
const saveBaseline = () => {
    window.dispatchEvent(
        new CustomEvent('baselineSaved', {
            detail: {
                payload: 'Baseline Price saved successfully',
                stopLoading: true,
                type: 'success',
            }
        })
    );
    return;
}

export default saveBaseline;
